export const BILLET_REPORT_DATE_TYPES = [
  { id: 1, label: 'Data de vencimento', value: 'dueDate' },
  { id: 2, label: 'Data de emissão do boleto', value: 'issueDate' },
  { id: 3, label: 'Data de emissão da apólice', value: 'policyIssueDate' },
  { id: 4, label: 'Data de pagamento', value: 'paymentDate' },
  { id: 5, label: 'Data limite de pagamento', value: 'limitPaymentDate' },
];
